import { MEASUREMENTS_ENABLE, MEASUREMENTS_LAYER_ADD_OR_GET, CANCEL_GET_FEATURE_INFO } from './actions.type';
import { MEASUREMENTS_ENABLED_SET, MEASUREMENTS_SHOW_MODAL } from './mutations.type';

import { Draw } from "ol/interaction";

import MeasurementStyleHelper from '../models/MeasurementsStyleHelper';

export const state = {
  enabled: false,
  drawInteraction: null
}

export const actions = {
  async [MEASUREMENTS_ENABLE]({ state, commit, dispatch, getters }, { type, unit }) {
    dispatch(CANCEL_GET_FEATURE_INFO);

    const layer = await dispatch(MEASUREMENTS_LAYER_ADD_OR_GET);
    const drawInteraction = new Draw({ source: layer.mapLayer.getSource(), type: type });
    const styleHelper = new MeasurementStyleHelper(type, unit);
    
    drawInteraction.on('drawstart', function(evt) { evt.feature.setStyle(styleHelper.getStyleFunction()); }, this);

    drawInteraction.on('drawend', function(evt) {
        evt.feature.setStyle(styleHelper.getDrawnStyleFunction());
        commit(MEASUREMENTS_ENABLED_SET, false);
      }, this);

    commit('setDrawInteraction', drawInteraction);
    commit(MEASUREMENTS_ENABLED_SET, true);
  }
}

export const mutations = {
  [MEASUREMENTS_ENABLED_SET](state, enabled) {
    state.enabled = enabled;
  },
  setDrawInteraction(state, interaction) {
    state.drawInteraction = interaction;
  },
  [MEASUREMENTS_SHOW_MODAL](state) {
    state.modalVisible = true;
  }
}

export const getters = {
  measurementsEnabled(state) {
    return state.enabled;
  },
  measurementDrawInteraction(state) {
    return state.drawInteraction;
  },
  measurementsModalVisible(state) {
    return state.modalVisible;
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}